export function createFileDownloadFromRawData(
  data: any,
  filename: string,
  mimeType?: string,
  format?: string
) {
  const downloadUrl = window.URL.createObjectURL(
    new Blob([data], { type: mimeType ?? "text/csv" })
  );
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.setAttribute("download", `${filename}.${format || "csv"}`);
  document.body.appendChild(link);
  link.click();
}

export function createExcelFileDownloadFromRawData(data: any, fileName: string) {
  const blobType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const blob = new Blob([data], { type: blobType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
